import { TextInfoRegistModel } from './vo/text-info-regist.model';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW0700OutputModel } from './vo/kymw0700-output.model';
import { PlessViewUtilsSub } from './../../kymw00/pless-view-utils-sub.service';
import { CheckNgWordsService } from './../../kymw02/check-ng-words/api-services/check-ng-words.service';
import { GetTextInfoService } from './api-services/get-text-info.service';
import { KYMW0700InputModel } from './vo/kymw0700-input.model';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0700Model } from './kymw0700.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { CellRange, CellType, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';

import { RegistTextInfoService } from './api-services/regist-text-info.service';
import { TextInfoModel } from './vo/text-info.model';
/**
 * 文字情報選択画面を管理するクラス
 *
 * @export KYMW0700Component
 * @class KYMW0700Component
 */
@Component({
  selector: 'app-kymw0700',
  templateUrl: 'kymw0700.component.html',
  styleUrls: ['kymw0700.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0700Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw0700Model: KYMW0700Model = new KYMW0700Model();

  @ViewChild('dg_TextInfoList', { static: true }) dg_TextInfoList: FlexGrid;
  /**
   * 画面受渡情報
   * 画面呼び出し時に受け渡されるオブジェクト
   */
  private inputVO: KYMW0700InputModel;

  public setKYMW0700Parameter: Function;

  public contextmenu: Menu;

  /** 読み取り専用フラグ */
  public isReadOnly: boolean = <boolean>false;

  /**
 * 権限「1」は閲覧モード「２」フルコントロール
 */
  public funcPermission: string = <string>'2';
  /**
   *Creates an instance of KYMW0700Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0700Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getTextInfoService: GetTextInfoService,
    private registTextInfoService: RegistTextInfoService,
    private checkNgWordsService: CheckNgWordsService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0700Component
   */
  public ngOnInit(): void {
    this.kymw0700Model.kymw0700Component = this;
    this.componentName = 'KYMW0700';
    this.dg_TextInfoList.selectionMode = SelectionMode.Row;

    // 画面から引き渡された値をManageに反映させる
    this.kymw0700Model.pCode = this.inputVO.goodsCode;	// Pコード
    this.kymw0700Model.goodsName = this.inputVO.goodsName; // 商品名
    this.kymw0700Model.guideStandardName = this.inputVO.guideGoodsName; // 規格名

    // 「商品企画メンテナンス」画面からの遷移
    // 「商品企画メンテナンス」「1物N価商品企画メンテナンス」「1物N価W掲載メンテナンス」画面からの遷移
    if (this.inputVO.formId === 'KYMW0900' || this.inputVO.formId === 'KYMW3001' || this.inputVO.formId === 'KYMW3201') {
      // 「商品企画メンテナンス」画面からの遷移時は、コンテキストメニューは表示されない
      // 文字列の変更は不可能とする
      // this.dg_TextInfoList.columns[2].isReadOnly = true;
      this.isReadOnly = true;
    } else {
      // 「商品企画メンテナンス」以外の画面からの遷移時は、コンテキストメニューを表示する
      this.createContextMenu();
    }

    // 商品付随文字情報マスタより、指定された商品付随文字情報種別の選択、文字列を表示するため、要求をサーバに送信する
    this.eventInfoSet_CLICKHandler();

    // ０：使用不可、１：閲覧のみ、２：フルコントロール可能（帳票出力、更新）
    this.funcPermission = this.getFuncPermission('KYMW1100');

    this.dg_TextInfoList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dg_TextInfoList.hitTest(e);
      if ((0 <= ht.row) && (1 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_text_info_${ht.row}`).click();
      }
    });

    this.dg_TextInfoList.focus();
  }

  public eventInfoSet_CLICKHandler(): void {
    // 商品付随文字情報マスタより、指定された商品付随文字情報種別の選択、文字列を表示するため、要求をサーバに送信する
    this.getTextInfoService.execute(this.kymw0700Model, this.inputVO);
  }

  public setInterfaceParam(param: any) {
    this.inputVO = <KYMW0700InputModel>param;
  }
  /**
   * 値入力後フォーカス遷移したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventCheckNgWordHandler(event: any): void {
    const strWrd: string = <string>event.target.value;

    // 届出表示・許可表示選択（商品文字情報種別：033）のときはNGワードチェックを行わない
    if (this.kymw0700Model.textKindID !== '033') {
      if (!PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trimDirection(strWrd, 1))) {
        const vo = {
          itemName: this.kymw0700Model.headerText.replace('選択', ''),
          string: event.target.value
        };
        this.checkNgWordsService.execute(this.kymw0700Model, vo);

      }
    }
  }

  /**
  * 設定ボタンを押下したときに呼び出されるメソッド。
  *
  * @param event コールバック・イベントへの参照
  */

  public eventSet_CLICKHandler(event: Event): void {
    // 「企画商品メンテナンス」「1物N価商品企画メンテナンス」「1物N価W掲載メンテナンス」から遷移した際は、サーバに値を送信しない。
    if (this.inputVO.formId === 'KYMW0900' || this.inputVO.formId === 'KYMW3001' || this.inputVO.formId === 'KYMW3201') {
      this.updateParent();
    } else {
      // 商品文字情報を登録するイベントを発行する
      // イベント生成時のVOも内部に設定している

      this.registTextInfoService.execute(this.kymw0700Model,
        new TextInfoRegistModel(this.kymw0700Model.pCode, this.kymw0700Model.textKindID, this.kymw0700Model.textInfoList));

    }
  }

  /**
   * 説明文一覧グリッドでコンテキストメニューが呼び出されたときの処理
   * @param event コンテキストメニューイベント
   */
  public eventDgTextInfoListContextMenu_MENUSELECTHandler(): void {
    // コンテキストメニューが「削除」の場合、選択のチェックが入っていないか確認する
    for (const contextMenuItem of this.contextmenu.itemsSource) {
      // コンテキストメニューの名称が「追加」である

      if (contextMenuItem.caption === '行追加') {
        contextMenuItem.enabled = true;

        // DataGridのDataProviderの件数が99件を超える状況であれば、コンテキストメニューの「追加」を非活性とする
        if (this.kymw0700Model.textInfoList.length >= 99) {
          contextMenuItem.enabled = false;
        }
      }

      // コンテキストメニューの名称が「削除」である

      if (contextMenuItem.caption === '行削除') {
        contextMenuItem.enabled = true;

        // DataGridが選択状態でなく、、選択されていない場合は、コンテキストメニューの「削除」を非活性とする
        if (this.dg_TextInfoList.selection.row < 0 || this.dg_TextInfoList.selectedItems[0].selectedFlg) {
          contextMenuItem.enabled = false;
        }
      }
    }
  }


  /**
  * 「説明文リスト」のコンテキストメニューで「追加」が選択されたときのイベント
  * @param contextMenuEvent イベント
  *
  */
  public eventDgTextInfoListAdd_CLICKHandler(): void {
    // データグリッドの末尾に新しいTextInfoVOを追加するため、作業用VOの生成を行う
    const addTextInfoVO: TextInfoModel = new TextInfoModel;

    // データグリッドのデータが存在しない場合は、1から番号を振り、存在する場合は、現在の要素数 + 1とする
    if (!PlessViewUtilsSub.isEmptyArray(this.dg_TextInfoList.itemsSource)) {
      addTextInfoVO.dispNum = this.dg_TextInfoList.itemsSource.length + 1;
    } else {
      addTextInfoVO.dispNum = 1;
    }

    // データ更新
    this.kymw0700Model.textInfoList = this.kymw0700Model.textInfoList.concat(addTextInfoVO);
  }

  /**
  * 「説明文リスト」のコンテキストメニューで「削除」が選択されたときのイベント
  * @param contextMenuEvent イベント
  *
   * @memberof KYMW0700Component
  */
  public eventDgTextInfoListDel_CLICKHandler(): void {
    const index = this.dg_TextInfoList.selection.row;
    const selectedItem = this.dg_TextInfoList.selectedItems[0];
    // データグリッドの列が選択されているか(念のため確認)
    if (index > -1) {
      const targetDispNum = selectedItem.dispNum;
      const targetIndex = this.kymw0700Model.textInfoList.findIndex(
        (item) => item.dispNum === targetDispNum);

      const tempList = PlessViewUtilsSub.getCloneArray(this.kymw0700Model.textInfoList);
      if (selectedItem.textKindNum < 0) {
        tempList.splice(targetIndex, 1);
      } else {
        tempList[index].deleteFlg = false;
      }
      // 再描画
      this.kymw0700Model.textInfoList = tempList;
    }
  }

  /**
   * 設定ボタンが押下可能か判断する(Son)
   */
  public checkBtnSetEnable(): void {
    // 閲覧モード
    if (this.funcPermission === '1') {
      this.kymw0700Model.enabledSet = false;
    } else {
      // 設定ボタンの使用可否判定
      this.kymw0700Model.enabledSet = true;
    }
  }

  /**
   * 「設定」ボタン押下後のCommand(TextInfoRegist)から呼び出される
   * 選択でチェックされた文字情報の商品付随文字選択VOを作成し、呼出元画面へ返却する。
   *
   */
  public updateParent(): void {
    // 保持しているArrayCollection分ループする
    for (const currentTextInfoVO of this.kymw0700Model.textInfoList) {
      // 扱いやすいように現在のカーソルのオブジェクトをキャスト

      // 選択のチェックがついている行を探す
      if (currentTextInfoVO.selectedFlg) {
        // KYMW0700OutputVOを生成し、呼出元に返す
        this.setKYMW0700Parameter(this.createKYMW0700OutputVO(currentTextInfoVO, this.kymw0700Model.textInfoList.length));
        break;
      } else {
        // 選択状態フラグがない場合(Son)
        this.setKYMW0700Parameter(this.createNullKYMW0700OutputVO(this.kymw0700Model.textInfoList.length));
      }
    }

    // DataGridに全て削除された場合。(Null)
    if (PlessViewUtilsSub.isEmptyArray(this.kymw0700Model.textInfoList)) {
      this.setKYMW0700Parameter(this.createNullKYMW0700OutputVO(0));
    }
  }

  /**
   * 文字情報から、親画面に返却するVOを生成する
   * @param textInfoVO
   * 	文字情報の1行に相当するVO
   * @return
   * 	親画面返却VO
   */
  public createKYMW0700OutputVO(textInfoVO: any, textInfoCount: number): KYMW0700OutputModel {
    const returnVO: KYMW0700OutputModel = new KYMW0700OutputModel();
    returnVO.stringValue = PlessViewUtilsSub.trimDirection(textInfoVO.stringValue, 1);
    returnVO.textKindId = this.kymw0700Model.textKindID;
    returnVO.textKindNum = textInfoVO.textKindNum;
    returnVO.textInfoCnt = textInfoCount + '件';
    return returnVO;
  }
  /**
   * 文字情報から、親画面に返却するVOを生成する(Son)
   * @param textInfoVO
   * 	文字情報が空白のVO
   * @return
   * 	親画面返却VO
   */
  public createNullKYMW0700OutputVO(textInfoCount: number): KYMW0700OutputModel {
    const returnVO: KYMW0700OutputModel = new KYMW0700OutputModel();
    returnVO.stringValue = '';
    returnVO.textKindId = this.kymw0700Model.textKindID;
    returnVO.textKindNum = -1;
    returnVO.textInfoCnt = textInfoCount + '件';

    return returnVO;
  }


  public createContextMenu(): void {
    this.contextmenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: '行追加', caption: '行追加', cmd: 'add',
            enabled: true
          },
          {
            header: '行削除', caption: '行削除', cmd: 'del',
            enabled: true
          },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.contextmenu.selectedValue) {
            case 'add':
              this.eventDgTextInfoListAdd_CLICKHandler();
              break;
            case 'del':
              this.eventDgTextInfoListDel_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dg_TextInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextmenu !== undefined) {
        const ht = this.dg_TextInfoList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dg_TextInfoList.select(grid, false);
          // 活性非活性設定
          this.eventDgTextInfoListContextMenu_MENUSELECTHandler();
          this.contextmenu.show(e);
        } else if (ht.cellType === CellType.None) {
          this.eventDgTextInfoListContextMenu_MENUSELECTHandler();
          // メニュー表示
          this.contextmenu.show(e);
        }
      }
    });
    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextmenu.itemsSource[0], 'none');
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextmenu.itemsSource[1], 'none');
  }


  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1100Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  public changeHandler() {
    const selectedIndex = this.dg_TextInfoList.selection.row;
    const value = this.dg_TextInfoList.selectedItems[0].selectedFlg;

    // 選択された箇所以外の他の行のチェックボックスをfalseにする
    for (let i = Number(0); i < this.kymw0700Model.textInfoList.length; i++) {
      // インデックスが、DataGridの変更箇所の列でなければ、選択を解除する
      if (i !== selectedIndex) {
        this.kymw0700Model.textInfoList[i].selectedFlg = false;
      }
    }
  }

  /**
   * 再描画時にフィルタリングを行う
   * 削除フラグがfalseのデータに関しては、表示しない
   */
  public doFilter(): void {
    let count = 1;
    this.dg_TextInfoList.rows.forEach((row) => {
      if (row.dataItem.deleteFlg) {
        row.visible = true;
        row.dataItem.dispNum = count;
        count++;
      } else {
        row.visible = false;
      }
    });
  }
}
